import React from "react";
import PropTypes from "prop-types";

import { RouteProducts } from "../../containers/Routes";

import DataTable from "../DataTable";

const COLUMNS = ["LineNumber", "Rate"];
function RouteProductstable({ id, onRowClick }) {
  return (
    <RouteProducts variables={{ where: { RouteRecIdRef: id } }}>
      {data => (
        <DataTable
          columns={COLUMNS}
          rows={data.RouteProducts}
          onRowClick={onRowClick}
        />
      )}
    </RouteProducts>
  );
}

RouteProductstable.propTypes = {
  id: PropTypes.number,
  onRowClick: PropTypes.func
};
export default RouteProductstable;
